import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core'
import { WindowRef } from '@spartacus/core'

@Directive({
  selector: '[mbInnerHtmlRendered]'
})
export class MbInnerHtmlRenderedDirective implements OnDestroy, OnInit {

  observer: MutationObserver | undefined
  @Output() innerHtmlRendered = new EventEmitter()

  constructor (private el: ElementRef,
               protected winRef: WindowRef) {
  }

  ngOnInit (): void {
    this.observer = this.winRef.isBrowser() ? new MutationObserver(mutations => {
      mutations?.forEach(mutation => {
        if (mutation.type === 'childList') {
          this.innerHtmlRendered.emit()
        }
      })
    }) : undefined
    this.observer?.observe(this.el?.nativeElement, { childList: true })
  }

  ngOnDestroy (): void {
    this.observer?.disconnect()
  }
}
